const BuildingsLayerIcon = () => {

  const iconStyles = `
    .icon_ct {
      fill: none;
      stroke: currentColor;
      stroke-width: 2;
      pointer-events: none;
    }
    .icon_bg {
      fill:rgba(0, 0, 0, 0);
      stroke: currentColor;
      stroke-width: 2;
    }
    .icon_bg:hover {
      fill: currentColor;
      fill-opacity: 0.3;
      stroke: currentColor;
      stroke-width: 2;
    }
    `;

	return (
		<svg
			viewBox={`0 0 100 100`}
			width={"100%"}
			height={"100%"}
    >
      <style>{iconStyles}</style>
      <path 
        className="icon_bg" 
        d="M50 8l-36 21v21l36 21 36 -21v-21z" />
      <path 
        className="icon_bg" 
        d="M50 71l-36 -21v21l36 21 36 -21v-21z" />
      <path 
        className="icon_ct" 
        d="M50 50l36 -21 M14 29l36 21 M50 92v-42 " />
    </svg>
  );
};

export default BuildingsLayerIcon;